import React from 'react'
import { usePlanFeatures } from '../hooks/usePlanFeatures'

const NavigationHeader = ({ 
  user, 
  currentMode, 
  onHome, 
  onLogout, 
  showHome = true, 
  showLogout = true,
  title = null 
}) => {
  const { planFeatures } = usePlanFeatures()

  return (
    <div className="header-responsive" style={{
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
    }}>
      {/* 左側: タイトルとプラン情報 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '24px' }}>🏮</span>
          <h1 className="text-responsive-lg" style={{ 
            margin: 0, 
            fontWeight: 'bold',
            color: '#333'
          }}>
            {title || 'ALSOK AI受付システム'}
          </h1>
        </div>
        
        {/* プラン表示 */}
        <div style={{
          backgroundColor: planFeatures.color,
          color: 'white',
          padding: '4px 12px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: 'bold'
        }}>
          {planFeatures.name}
        </div>
      </div>

      {/* 中央: ユーザー情報 */}
      {user && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: '#f8f9fa',
          padding: '6px 12px',
          borderRadius: '20px',
          fontSize: '14px'
        }}>
          <span style={{ fontSize: '16px' }}>👤</span>
          <span style={{ fontWeight: '500' }}>{user.name}</span>
          <span style={{ 
            color: '#666', 
            fontSize: '12px',
            marginLeft: '4px'
          }}>
            ({user.role === 'administrator' ? '管理者' : 
              user.role === 'staff' ? 'スタッフ' : '受付専用'})
          </span>
        </div>
      )}

      {/* 右側: ナビゲーションボタン */}
      <div className="nav-responsive" style={{ gap: '8px', alignItems: 'center' }}>
        {showHome && onHome && (
          <button
            onClick={onHome}
            style={{
              padding: '8px 16px',
              backgroundColor: planFeatures.color,
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => e.target.style.opacity = '0.8'}
            onMouseOut={(e) => e.target.style.opacity = '1'}
          >
            🏠 ホーム
          </button>
        )}
        
        {showLogout && onLogout && (
          <button
            onClick={onLogout}
            style={{
              padding: '8px 16px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => e.target.style.opacity = '0.8'}
            onMouseOut={(e) => e.target.style.opacity = '1'}
          >
            🚪 ログアウト
          </button>
        )}
      </div>
    </div>
  )
}

export default NavigationHeader